module.exports = __webpack_public_path__ + "media/winner_single_line_3.f6ea23ba.mp3";